var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({staticClass:"pa-0 text-capitalize",attrs:{"small":"","color":"primary","text":"","to":_vm.to}},_vm.$listeners),[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }